var map = {
	"./01.jpg": 57121,
	"./01.webp": 9465,
	"./02.jpg": 23862,
	"./02.webp": 29788,
	"./03.jpg": 79123,
	"./03.webp": 8031,
	"./04.jpg": 38816,
	"./04.webp": 26594,
	"./05.jpg": 64381,
	"./05.webp": 82157,
	"./06.jpg": 45426,
	"./06.webp": 8448,
	"./Thumbs.db": 20079,
	"./backup-icon.svg": 6242,
	"./cdn-icon.svg": 94955,
	"./cicd-icon.svg": 87635,
	"./cpu-ram-ssd-icon.svg": 44420,
	"./docker-icon.svg": 93976,
	"./ha-scalability-icon.svg": 15445,
	"./hosting-icon.svg": 31002,
	"./large/01.jpg": 1173,
	"./large/01.webp": 47573,
	"./large/02.jpg": 9098,
	"./large/02.webp": 24520,
	"./large/03.jpg": 76839,
	"./large/03.webp": 32459,
	"./local-offsite-backup-icon.svg": 79853,
	"./mail-server-vps-icon.svg": 32011,
	"./managed-vps-icon.svg": 34427,
	"./microservices-icon.svg": 12468,
	"./ports-reverse-proxy-icon.svg": 54734,
	"./shared-to-vps-icon.svg": 90767,
	"./ssh-icon.svg": 11270,
	"./ssh.png": 13940,
	"./subdomains-servers-icon.svg": 20630,
	"./vps-use-cases-icon.svg": 68149,
	"./vps-vs-shared-icon.svg": 88421,
	"./website-vs-webapp-icon.svg": 43211,
	"./woocommerce-icon.svg": 58796,
	"./wordpress-icon.svg": 30959,
	"./wordpress-popularity-icon.svg": 56937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34346;